import React, { useState } from 'react';
import AdminCategories from './Admincategories';
import AdminVideos from './Adminvideos';
import AdminPlans from './Adminplans';
import './Videoapi.css';

const NAV = [
  { id: 'categories', label: 'Categories', icon: '📂' },
  { id: 'videos',     label: 'Videos',     icon: '🎬' },
  { id: 'plans',      label: 'Plans',       icon: '💰' },
];

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('categories');

  const renderContent = () => {
    if (activeTab === 'categories') return <AdminCategories />;
    if (activeTab === 'videos')     return <AdminVideos />;
    if (activeTab === 'plans')      return <AdminPlans />;
    return null;
  };

  return (
    <div className="videoadmin-wrapper">
      {/* Tab Bar — no sidebar, lives inside AdminLayout */}
      <div className="videoadmin-tabs">
        {NAV.map(item => (
          <button
            key={item.id}
            className={`videoadmin-tab ${activeTab === item.id ? 'active' : ''}`}
            onClick={() => setActiveTab(item.id)}
          >
            <span>{item.icon}</span>
            {item.label}
          </button>
        ))}
      </div>

      {/* Page content rendered inside main layout */}
      <div className="videoadmin-content">
        {renderContent()}
      </div>
    </div>
  );
}